import { parsePhoneNumberFromString } from "libphonenumber-js/min";

const normalizePhoneInput = (input: string): string => {
  const trimmed = input.trim();
  if (!trimmed) return "";

  if (trimmed.startsWith("+")) {
    return trimmed;
  }

  const digits = trimmed.replace(/\D/g, "");
  if (!digits) return trimmed;

  if (digits.startsWith("00")) {
    return `+${digits.slice(2)}`;
  }
  if (digits.startsWith("0")) {
    return `+46${digits.slice(1)}`;
  }
  if (digits.startsWith("46")) {
    return `+${digits}`;
  }
  return `+${digits}`;
};

export const formatPhoneNumber = (input: string | undefined): string => {
  if (input === undefined || !input.trim()) return "";

  const normalized = normalizePhoneInput(input);
  const parsed = parsePhoneNumberFromString(normalized, "SE");

  if (parsed?.isValid()) {
    return parsed.formatInternational();
  }

  return normalized;
};
